import React from 'react';
import { useSpring, animated } from 'react-spring';

import"../../CSS/ProjectPageStyle.css";

const InterestsAndAwards = () => {
    const props = useSpring({
        opacity: 1,
        color: 'white',
        from: { opacity: 0 },
        delay: '2000'
    })
    return (
    <animated.div style={props}>
        <div className="project-page">
            <div className="project-title">Interests and Awards</div>
            <div className="experience-block">
                <div className="cv-box">
                    <div className="cv-box-title">U.S. Patents</div>
                </div>
                <div>
                    Co-inventor on three granted U.S. patents in machine learning, satellite-image flare detection,
                    flare efficiency monitoring, and drilling-report information extraction: U.S. Patent Nos.
                    12614384, 12313260, and 12129755.
                </div>
            </div>
            <div className="experience-block">
                <div className="cv-box">
                    <div className="cv-box-title">Richmond Light Orchestra</div>
                </div>
                <div>
                    Charity Trustee, IT manager and 1st Violin of Richmond Light Orchestra.
                </div>
            </div>
        </div>
    </animated.div>
    )
}

export default InterestsAndAwards;
